import React, { useState } from "react";
import { useDispatch } from "react-redux";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router";
import axios from "axios";
import moment from "moment";
import {
  Segment,
  Button,
  Header,
  Divider,
  Container,
  Label,
} from "semantic-ui-react";
import styled from "@emotion/styled";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!'
import timeGridPlugin from "@fullcalendar/timegrid";
import listMonth from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
// import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "@fullcalendar/timegrid/main.css";
import "semantic-ui-css/semantic.min.css";
import "@fullcalendar/daygrid/main.css";
import { ObjNotificaciones } from "../../../../config/notificaciones";
import {
  edicionConvocatoria,
  idConvocatorias,
} from "../../../../redux/actions/convocatoriaAction";
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import { HomeFilled } from "@ant-design/icons";
import apiConvocatorias from "../../../../api/Convocatorias/api-convocatorias";
import { Navegador } from "../../../../components/Administrador/NavegadorConvocatoria/Navegador";
import { openNotification } from "../../../../utils/saveFile";
import { useEncrypt } from "../../../../hooks/useEncrypt";
import ModalCronograma from "./ModalCronograma";
// registerLocale("es", es);
var conteoFechas = 0;
export const StyleWrapper = styled.div`
  .fc-button.fc-button-primary {
    background: white;
    color: #101c31;
    border-color: #101c31;
    padding-left: 17%;
    padding-right: 17%;
  }
  .fc-button.fc-prev-button,
  .fc-button.fc-next-button {
    background: white;
    color: #101c31;
    border-color: #101c31;
    padding-left: 10px;
    padding-right: 10px;
  }
  .fc-button.fc-prev-button span,
  .fc-button.fc-next-button span {
    margin-left: 0;
  }
  .fc-button.fc-button-primary.fc-button-active {
    background: #101c31;
    padding-top: 6%;
    padding-bottom: 6%;
    padding-left: 18%;
    padding-right: 18%;
  }
  .fc-toolbar-title {
    font-family: "Montserrat-Regular", sans-serif;
    text-transform: capitalize;
    font-weight: normal;
    font-size: 22px;
    letter-spacing: 0px;
    text-transform: lowercase;
  }
  .fc-col-header-cell.fc-day.fc-day-sun,
  .fc-col-header-cell.fc-day.fc-day-mon,
  .fc-col-header-cell.fc-day.fc-day-tue,
  .fc-col-header-cell.fc-day.fc-day-wed,
  .fc-col-header-cell.fc-day.fc-day-thu,
  .fc-col-header-cell.fc-day.fc-day-fri,
  .fc-col-header-cell.fc-day.fc-day-sat {
    background: #101c31;
    border: 1px solid #101c31;
  }
  .fc-col-header-cell-cushion {
    color: white;
    text-transform: uppercase;
  }
  .fc-daygrid-day-number {
    color: black;
  }
  .fc-day-today.fc-daygrid-day-number {
    background: #101c31;
  }
  .fc-time-grid .fc-content-skeleton {
    position: absolute;
    z-index: 3;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
  }
  .fc-toolbar-chunk {
    width: 22%;
  }
  .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-top a {
    background: #101c31;
    color: white;
    border-radius: 1rem;
  }
  .fc-today-button {
    border-radius: 19px;
    padding-left: 17% !important;
    padding-right: 17% !important;
  }
  .fc-toolbar-chunk:nth-of-type(2) {
    width: 50%;
    display: flex;
    justify-content: flex-end;
  }
  .fc-daygrid-day-frame {
    background-color: #ffffff;
  }
  .fc-daygrid-event-harness {
    background-color: #051923bf;
    color: white;
  }
  .fc-daygrid-event-harness a {
    background-color: #051923bf !important;
    border: 1px solid #051923bf !important;
    color: white;
  }
  .fc-event-title {
    color: #ffffff;
  }
  .fc-event-time {
    display: none;
  }
  .fc-daygrid-event-dot {
    display: none;
  }
  .fc-daygrid-event-harness {
    margin-left: 5px;
    margin-right: 5px;
  }
`;
export const Cronograma = () => {
  const stateError = {
    apertura: false,
    cierre: false,
    otorgamiento: false,
  };
  const CalendarRef = React.useRef();
  const history = useNavigate();
  const dispatch = useDispatch();
  // const { idConvocatoria } = useSelector((state) => state.convocatoria);

  const { decrypt } = useEncrypt();
  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));

  // const { editarConvocatoria } = useSelector((state) => state.edicion);
  const [principalError, setPrincipalError] = useState(stateError);
  const [, setActividad] = React.useState({ text: "" });
  const [open, setOpen] = React.useState(false);
  // FECHA DE INICIO
  const [fechainiciodia, setFechainiciodia] = React.useState();
  const [fechainiciomes, setFechainiciomes] = React.useState();
  const [fechainicioaño, setFechainicioaño] = React.useState();
  const [, setHora] = React.useState("23");
  const [, setMinuto] = React.useState("59");
  // EVENTOS
  const [eventosCalendario, setEventosCalendar] = React.useState([]);
  const [eventoid, setEventoId] = React.useState("");
  const [editarmodal, setEditarModal] = React.useState(false);
  const [loading, setLoading] = useState(false);
  // PRINCIPAL STATE
  const stateInitial = {
    rango_fechassi: false,
    rango_fechasno: true,
    hora_cierresi: false,
    hora_cierreno: true,
    verFechas: false,
    verHoras: false,
    hora: "12",
    minuto: "00",
    formato_pm: true,
    formato_am: false,
    fechainicio: "",
    fechafinal: "",
    rango_fechas: "no",
    hora_cierre: "no",
  };
  const stateErrores = {
    actividad: false,
  };
  const [principalState, setPrincipalState] = React.useState(stateInitial);
  const [, setErrorState] = React.useState(stateErrores);
  const [actividadesSeleccionadas, setActividadesSeleccionadas] = useState([]);

  React.useEffect(() => {
    handelCargarActividadesSeleccionadas();
    primerasFechas();
  }, []);

  async function primerasFechas() {
    const token = localStorage.getItem('token')
    let response = await axios.get(
      `${process.env.REACT_APP_SERVER_CONV}convocatorias/${idConvocatoria}`,
      {
        headers: {
          'Authorization': token
        }
      }
    );
    if (response.data.data.length === 0) return;
    var events = [];
    if (response.data.data.fechas === null) return;
    for (var i in response.data.data.fechas) {
      let fechainicio = moment(response.data.data.fechas[i].valormin).format(
        "YYYY-MM-DD HH:mm"
      );
      let fechafin = moment(response.data.data.fechas[i].valormax).format(
        "YYYY-MM-DD HH:mm"
      );
      if (fechafin.trim() === "Invalid date") fechafin = null;
      if (response.data.data.fechas[i]) {
        events = [
          ...events,
          {
            id: i,
            title: response.data.data.fechas[i].clave,
            start: fechainicio,
            end: fechafin,
            allDay: true,
          },
        ];
      }
    }

    return setEventosCalendar(events);
  }

  function adicionarActividad() {
    let fechacompleta;
    let fechafinalaño;
    let fechafinalmes;
    let fechafinaldia;
    let horaTest;
    let minutoTest;

    setHora(principalState.hora);
    setMinuto(principalState.minuto);

    //Validar que la actividada no esté en los eventos del calendario
    const ValActEve = eventosCalendario.filter((e) => e.title == principalState.actividad);
    if (ValActEve.length > 0) {
      return openNotification({
        titulo: "Error",
        descripcion:
          "Esta Actividad ya está programada en el calendario, Debes eliminarla primero antes de asignar una nueva fecha.",
      });
    }
    
    if (!moment(principalState.fechafinal).isValid()) {
      let inicio=principalState.fechainicio
      setPrincipalState({
        ...principalState,
        fechafinal: inicio
      }); 
    }

    fechafinalaño = moment(principalState.fechafinal).format("YYYY");
    fechafinalmes = moment(principalState.fechafinal).format("MM");
    fechafinaldia = moment(principalState.fechafinal).format("DD");
    horaTest = principalState.hora;
    minutoTest = principalState.minuto;

    let apertura = eventosCalendario.filter(
      (data) => data.title == "Apertura"
    );

    let afechaini
    let avfechaini
    let afechafin
    let avfechafin
    if (apertura.length > 0) {
      afechaini = apertura[0].start
      avfechaini = afechaini && moment(afechaini).isValid()
      afechafin = apertura[0].end
      avfechafin = afechafin && moment(afechafin).isValid()
    }

    let cierre = eventosCalendario.filter(
      (data) => data.title == "Cierre"
    );
    let cfechaini
    let cvfechaini
    let cfechafin
    let cvfechafin
    if (cierre.length > 0) {
      cfechaini = cierre[0].start
      cvfechaini = cfechaini && moment(cfechaini).isValid()
      cfechafin = cierre[0].end
      cvfechafin = cfechafin && moment(cfechafin).isValid()
    }
    let resolucion = eventosCalendario.filter(
      (data) => data.title == "Resolución de otorgamiento"
    );
    let rfechaini
    let rvfechaini
    let rfechafin
    let rvfechafin
    if (resolucion.length > 0) {
      rfechaini = resolucion[0].start
      rvfechaini = rfechaini && moment(rfechaini).isValid()
      rfechafin = resolucion[0].end
      rvfechafin = rfechafin && moment(rfechafin).isValid()
    }

    //validar Actividad Apertura
    if (principalState.actividad === "Apertura") {
      let estado = true
      if (cierre.length > 0) {
        if (cvfechaini && cvfechafin) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isBefore(moment(cfechaini))
            && moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isBefore(moment(cfechafin));

        } else if (cvfechaini) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isBefore(moment(cfechaini));
        } else if (cvfechafin) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isBefore(moment(cfechafin));
        } else {
          estado = false
        }
      }
      if (resolucion.length > 0) {
        if (rvfechaini && rvfechafin) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isBefore(moment(rfechaini))
            && moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isBefore(moment(rfechafin))

        } else if (rvfechaini) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isBefore(moment(rfechaini));
        } else if (rvfechafin) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isBefore(moment(rfechafin));
        } else {
          estado = false
        }
      }
      if (!estado) {
        return openNotification({
          titulo: "Error",
          descripcion:
            "La fecha de la actividad de Apertura debe ser menor que las Actividades de Cierre y Resolución de Otorgamiento",
        });
      }
    }
    //validar Actividad Cierre
    else if (principalState.actividad === "Cierre") {
      let estado = true
      if (apertura.length > 0) {
        if (avfechaini && avfechafin) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isAfter(moment(afechaini))
            && moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isAfter(moment(afechafin));

        } else if (avfechaini) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isAfter(moment(afechaini));
        } else if (avfechafin) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isAfter(moment(afechafin));
        } else {
          estado = false
        }
      }
      if (resolucion.length > 0) {
        if (rvfechaini && rvfechafin) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isBefore(moment(rfechaini))
            && moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isBefore(moment(rfechafin))

        } else if (rvfechaini) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isBefore(moment(rfechaini));
        } else if (rvfechafin) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isBefore(moment(rfechafin));
        } else {
          estado = false
        }
      }
      if (!estado) {
        return openNotification({
          titulo: "Error",
          descripcion:
            "La fecha de la actividad de Cierre debe ser mayor que la fecha de la Actividad de Apertura y menor que la fecha de la actividad de Resolución de Otorgamiento",
        });
      }
    }
    //validar Actividad Resolución
    else if (principalState.actividad === "Resolución de otorgamiento") {
      let estado = true
      if (apertura.length > 0) {
        if (avfechaini && avfechafin) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isAfter(moment(afechaini))
            && moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isAfter(moment(afechafin));

        } else if (avfechaini) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isAfter(moment(afechaini));
        } else if (avfechafin) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isAfter(moment(afechafin));
        } else {
          estado = false
        }
      }
      if (cierre.length > 0) {
        if (cvfechaini && cvfechafin) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isAfter(moment(cfechaini))
            && moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isAfter(moment(cfechafin))

        } else if (cvfechaini) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isAfter(moment(cfechaini));
        } else if (cvfechafin) {
          estado =
            moment(`${fechainicioaño}-${fechainiciomes}-${fechainiciodia}`)
              .isAfter(moment(cfechafin));
        } else {
          estado = false
        }
      }
      if (!estado) {
        return openNotification({
          titulo: "Error",
          descripcion:
            "La fecha de la Actividad de Resolución de Otorgamiento debe ser mayor que la Actividad de Apertura y de Cierre",
        });
      }
    }

    let id = eventosCalendario.length;
    const calendarApi = CalendarRef.current.getApi();
    if (principalState.actividad.trim() === "") {
      return setErrorState({ actividad: true });
    }

    if (principalState.actividad.trim() === "Apertura") {
      setPrincipalError({ ...principalError, apertura: false });
    }
    if (principalState.actividad.trim() === "Cierre") {
      setPrincipalError({ ...principalError, cierre: false });
    }
    if (principalState.actividad.trim() === "Resolución de otorgamiento") {
      setPrincipalError({ ...principalError, otorgamiento: false });
    }
    calendarApi.unselect();
    setOpen(false);
    let events = [];
    if (editarmodal) {
      events = [...eventosCalendario];
      events[eventoid].title = principalState.actividad;
      events[eventoid].start = `${fechainicioaño}-${fechainiciomes}-${fechainiciodia} 06:00`;
      events[eventoid].end = `${fechafinalaño}-${fechafinalmes}-${fechafinaldia} ${horaTest}:${minutoTest}`;
    } else {
      events = [...eventosCalendario,
      {
        id: id,
        title: principalState.actividad,
        start: `${fechainicioaño}-${fechainiciomes}-${fechainiciodia} 06:00`,
        end: `${fechafinalaño}-${fechafinalmes}-${fechafinaldia} ${horaTest}:${minutoTest}`,
        allDay: false,
      },
      ];
    }

    let nuevasactividades = actividadesSeleccionadas.filter(
      (i) => i.text !== principalState.actividad
    );
    setActividadesSeleccionadas(nuevasactividades);
    setEditarModal(false);
    setEventoId("");
    setPrincipalState(stateInitial);
    return setEventosCalendar(events);
    // return calendarApi.addEvent({
    //   id: id,
    //   title: actividad.text,
    //   start: `${fechainicioaño}-${fechainiciomes}-${fechainiciodia} 06:00`,
    //   end: `${fechafinalaño}-${fechafinalmes}-${fechafinaldia} ${hora}:${minuto}`,
    //   allDay: false,
    // });
  }

  const grabandoActividades = async () => {
    try {
      setLoading(true);
      let id_convocatoria = idConvocatoria;
      let calendaroptions = CalendarRef.current.getApi();
      let events = calendaroptions.getEvents();
      if (events.length === 0) {
        setLoading(false);
        return openNotification({
          titulo: "Error",
          descripcion:
            "No se han asociado fechas a las actividades seleccionadas de la convocatoria",
        });
      }
      let fechasvalues = eventosCalendario.map((data, index) => {
        return {
          id: index,
          id_convocatoria,
          clave: data.title,
          valormin: data.start,
          valormax: data.end,
        };
      });
      await apiConvocatorias.guardarFechas(idConvocatoria, fechasvalues);
      await ObjNotificaciones.MSG_SUCCESS(
        "success",
        "Se han asociado las actividades al cronograma"
      );
      setLoading(false);
      return history("/Administrador/documentos");
    } catch (error) {
      setLoading(false);
      return console.error(error);
    }
  };
  const handelCargarActividadesSeleccionadas = async () => {
    try {
      let { data } = await apiConvocatorias.consultarActividadesSeleccionadas(
        idConvocatoria
      );

      if (data !== null) {
        let _actividadesseleccionadas = data.map((data) => {
          return {
            key: data.key,
            value: data.id,
            text: data.nombre,
          };
        });

        setActividadesSeleccionadas(_actividadesseleccionadas);
      }
    } catch (error) {
      return console.error(error);
    }
  };
  const backComponente = () => {
    dispatch(edicionConvocatoria(true));
    dispatch(idConvocatorias(idConvocatoria));
    return history("/administrador/cronogramaActividades");
  };
  // routes
  const routes = [
    { icon: <HomeFilled />, nombre: "" },
    { nombre: "Crear convocatoria" },
  ];
  const actividadeditar = (event) => {
    return setActividad({
      key: parseInt(event.event.id),
      value: parseInt(event.event.id),
      text: event.event._def.title,
    });
  };
  return (
    <div className="container-flexbox background-color-F7FBFF height-100">
      <div className="no-margin">
        <div className="background-color-101c31 no-margin no-padding-top no-padding-bottom">
          <BreadCrumbAdmin routes={routes} />
        </div>
      </div>
      <Navegador idconvocatorias={idConvocatoria} activo="Cronograma" />
      <div className="container-fluid background-color-F7FBFF ps-md-4 pe-md-4 main-c3">
        <div className="mt-2">
          <Segment
            style={{ paddingLeft: "16px", paddingRight: "16px" }}
            className="segment-shadow"
          >
            <Header
              as="h4"
              className="font-size-14px font-color-1B1C1D font-family-Montserrat-SemiBold"
              style={{ marginBottom: "0.5%" }}
              floated="left"
            >
              Cronograma
            </Header>
            <Header as="h4" floated="right" style={{ marginBottom: "0.5%" }}>
              <span className="font-color-B0B0B0 font-family-Montserrat-Thin font-size-12px">
                Código de convocatoria {idConvocatoria}
              </span>
            </Header>
            <Divider
              clearing
              style={{ marginTop: "0", marginBottom: "0%" }}
            />
            <StyleWrapper style={{ padding: "1%" }}>
              <FullCalendar
                plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin, listMonth]}
                initialView="dayGridMonth"
                weekends={true}
                droppable={true}
                locale="es"
                height={895}
                eventClick={(event) => {
                  //Al darle click al evento eliminar
                  let infoupdate = [...actividadesSeleccionadas];
                  if (actividadesSeleccionadas.filter((e) => e.text === event.event._def.title).length < 1) {
                    infoupdate.push({
                      key: parseInt(event.event.id),
                      value: parseInt(event.event.id),
                      text: event.event._def.title,
                    })
                  }
                  setActividadesSeleccionadas(infoupdate);
                  let evt = eventosCalendario.filter(x => x.title != event.event.title)
                  setEventosCalendar(evt)
                  return
                }}
                headerToolbar={{
                  start: "listMonth,dayGridMonth",
                  center: "title",
                  end: "prev,next today",
                }}
                buttonText={{
                  today: "Hoy",
                  list: "Lista",
                  month: "Mes",
                  week: "Semana",
                  day: "Día",
                }}
                allDayText="Todo el día"
                dateClick={(info) => {
                  setFechainicioaño(moment(info.date).format("YYYY"));
                  setFechainiciomes(moment(info.date).format("MM"));
                  setFechainiciodia(moment(info.date).format("DD"));
                  setPrincipalState({
                    ...principalState,
                    fechainicio: moment(info.date).format("YYYY-MM-DD"),
                    fechafinal: moment(info.date).format("YYYY-MM-DD"),
                  });
                  return setOpen(true);
                }}
                events={eventosCalendario}
                eventColor="#FFFFFF"
                ref={CalendarRef}
              />
            </StyleWrapper>
            <Container textAlign="right">
              {principalError.apertura ? (
                <Label color="red">Falta asignar la Apertura</Label>
              ) : null}
              {principalError.cierre ? (
                <Label color="red">Falta asignar el Cierre</Label>
              ) : null}
              {principalError.otorgamiento ? (
                <Label color="red">
                  Falta asignar la Resolución de otorgamiento
                </Label>
              ) : null}
            </Container>
          </Segment>
        </div>
      </div>

      <nav className="buttonNext border-top pe-3 justify-content-flex-start bg-white">
        <div className="row">
          <div className="col justify-content-flex-start">
            <Button
              className="button-blanco-radius"
              onClick={backComponente}
            >
              Atrás
            </Button>
          </div>
          <div className="col justify-content-flex-end">
            <Button
              className="button-azul-radius"
              color="blue"
              onClick={grabandoActividades}
              disabled={loading}
            >
              Guardar y continuar
              {loading && (
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
                />
              )}
            </Button>
          </div>
        </div>
      </nav>

      <ModalCronograma
        open={open}
        setOpen={setOpen}
        stateInitial={stateInitial}
        principalState={principalState}
        setPrincipalState={setPrincipalState}
        adicionarActividad={adicionarActividad}
        actividadesSeleccionadas={actividadesSeleccionadas}
      />


    </div>
  );
};
